module.exports = "<h3 *ngIf=\"!isDraw\" translate>menu.schoolarea.school_area</h3>\n<h3 *ngIf=\"isDraw\" translate>menu.schoolarea.school_area_draw</h3>\n"